module.exports = __webpack_public_path__ + "img/legend_b.bb96f70a.png";